import type { FaireProductEntity } from "../../entity_types/product";

export const p_9z34rt5vfg: FaireProductEntity = {
  token: "p_9z34rt5vfg",
  type: "product",
  name: "Sunburnt",
  brandToken: "b_qkjzzyp79p",
  brandName: "Nose Dive",
  imageUrl:
    "https://cdn.faire.com/fastly/5b48f92e4b64aac1f07ae4680ec9430d482eb0be9fc3466abbb86f85e9a0fc26.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bce34026ce7df3e6c744c622340be66df26fe745dee32eac37e89f22fbffcb1.jpeg",
    "https://cdn.faire.com/fastly/468f6805d1f94ab2345f9b26dfbda4ceff8dd48470c12aba4735d3fd36969913.jpeg",
    "https://cdn.faire.com/fastly/a95fdcfdb844fedbc56266e16bbf14bda461638f49d1ce5b273d5294ef52d8b4.jpeg",
    "https://cdn.faire.com/fastly/c05880f329c220b0e819166cadf7e9a57509800f1675e43d3060f32993d7a442.jpeg",
    "https://cdn.faire.com/fastly/78f0e917256e934e31dc98ef9d7be7e7bc6e7d78de8d98b10cd147508c051de0.jpeg",
  ],
  priceDollars: 22,
  description:
    "A little buzzed, a little sunkissed. Sunburnt captures the dreamy blur of summer evenings — warm skin, ocean waves, and the luxury of time spent nowhere but here.\n\nTop Notes: iris, pink pepper, ambroxyn, ambrette, white musk\n\nMiddle Notes: sicilian lemons, mandarin orange, calming ozone\n\nBase Notes: cyclamen, wild jasmine, red rose, soft amber\n\nFounder's Note: \"This candle just makes me happy. It's salty, bright, complex and feminine. It embodies the feeling of being on vacation -- after being in the sun, a few glasses of rosé deep watching the sun start to set. If I could turn this into a perfume I would.\"\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:55.700Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
